import { FC } from 'react';
import compose from '../../../utils/components/_compose';
import withSpacing from '../../../hocs/grid/withSpacing';

import MainContentZone, { MainContentZoneProps } from './MainContentZone';

export * from './MainContentZone';

export default compose<FC<MainContentZoneProps>>(
  withSpacing,
)(MainContentZone);
